$.fn.passwordRequirementChecker = function () {
  initialize(this.val());
  this.on('input change', function (e) {
    validateInput(e.target.value);
  });

  function criteriaMet(domId) {
    $('#' + domId)
      .removeClass('criteria-not-met glyphicon-remove fa-remove text-danger')
      .addClass('criteria-met glyphicon-ok fa-check text-success');
  }

  function criteriaNotMet(domId) {
    $('#' + domId)
      .addClass('criteria-not-met glyphicon-remove fa-remove text-danger')
      .removeClass('criteria-met glyphicon-ok fa-check text-success');
  }

  function initialize(currentValue) {
    validateInput(currentValue);
  }

  function validateInput(inputValue) {
    var hasLowerCase = /[a-z]/.test(inputValue);
    var hasUpperCase = /[A-Z]/.test(inputValue);
    var hasNumbers = /[0-9]/.test(inputValue);
    var hasSpecialCharacters = /[~!@@#$%^&*_\-\+=`|\\(){}\[\]:;"'<>,.?\\]/.test(
      inputValue
    );

    var requirementsMet = 0;

    if (inputValue && inputValue.length >= 5) {
      criteriaMet('password-length-requirement');
    } else {
      criteriaNotMet('password-length-requirement');
    }

    if (hasLowerCase) {
      requirementsMet++;
    }

    if (hasUpperCase) {
      requirementsMet++;
    }

    if (hasNumbers) {
      requirementsMet++;
    }

    if (hasSpecialCharacters) {
      requirementsMet++;
    }

    if (requirementsMet >= 3) {
      criteriaMet('password-combination-requirement');
    } else {
      criteriaNotMet('password-combination-requirement');
    }
  }
};
